var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "popup",
        {
          attrs: { open: _vm.open },
          on: {
            "update:open": function($event) {
              _vm.open = $event
            }
          }
        },
        [
          _c("div", { staticClass: "popup-header" }, [
            _c("h3", [_vm._v("Account Analysis")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "scrollable" }, [
            _c("div", { staticClass: "content-form" }, [
              _c(
                "div",
                { staticClass: "form-row form-split justify-content-center" },
                [
                  _c("form-field-select", {
                    attrs: {
                      label: "Select Analysis Type",
                      validator: _vm.$v.form.currencyType,
                      options: _vm.currencyTypeOptions,
                      required: ""
                    },
                    model: {
                      value: _vm.form.currencyType,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "currencyType", $$v)
                      },
                      expression: "form.currencyType"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "buttons text-center" }, [
              _c(
                "button",
                {
                  staticClass: "main",
                  attrs: { disabled: this.$v.form.$invalid },
                  on: {
                    click: function($event) {
                      return _vm.run()
                    }
                  }
                },
                [_vm._v("Start")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "second",
                  on: {
                    click: function($event) {
                      _vm.open = false
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "popup",
        {
          attrs: { open: _vm.error, width: 400 },
          on: {
            "update:open": function($event) {
              _vm.error = $event
            }
          }
        },
        [
          _c("div", { staticClass: "popup-header" }, [
            _c("h3", [_vm._v("Error")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "scrollable" }, [
            _c("div", { staticClass: "content-form" }, [
              _c("div", { staticClass: "form-row" }, [
                _c("p", [_vm._v(_vm._s(_vm.errors))])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "second",
                on: {
                  click: function($event) {
                    _vm.error = false
                  }
                }
              },
              [_vm._v("Close")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }